import React, { useState } from "react";
import { login } from "../../Actions/LoginAction";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

const Login = () => {
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [helperText, setHelperText] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const isLoginUser = useSelector(
    (state) => state.LoginReducer.isLoginUser
  );

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (validateEmail(value)) {
      setError(false);
      setHelperText("");
    } else {
      setError(true);
      setHelperText("Please enter a valid email address");
    }
  };

  const handlePasswordChange = (e) => setPassword(e.target.value);

  const handleDangerVisible = (err) => {
    Swal.fire({
      title: "Error",
      text: err,
      icon: "error",
      timer: 30000,
    });
  };

  const handleLogin = () => {
    dispatch(
      login(
        {
          email: email,
          password: password,
        },
        handleDangerVisible,
      )
    );
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-8">
        <h1 className="text-3xl font-bold text-center mb-6">Admin Login</h1>

        {/* Email Label */}
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Email
        </label>
        <input
          type="email"
          placeholder="test@gmail.com"
          value={email}
          onChange={handleChange}
          className={`w-full px-3 py-2 border ${
            error ? "border-red-500" : "border-gray-300"
          } rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
        />
        {helperText && (
          <p className="text-red-500 text-xs mt-1">{helperText}</p>
        )}

        {/* Password Label */}
        <label className="block text-sm font-medium text-gray-700 mt-4 mb-1">
          Password
        </label>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="********"
            value={password}
            onChange={handlePasswordChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-3 flex items-center text-gray-500"
          >
            {showPassword ? "🙈" : "👁️"}
          </button>
        </div>

        {/* Submit Button */}
        <button
          type="button"
          onClick={handleLogin}
          disabled={email === "" || password === "" || error}
          className={`w-full mt-6 py-2 text-white font-semibold rounded-md transition-all duration-300 ${
            email === "" || password === "" || error
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-gradient-to-r from-blue-600 to-indigo-500 hover:opacity-90"
          }`}
        >
          {isLoginUser ? (
            <span className="flex items-center justify-center">
              <svg
                className="animate-spin h-5 w-5 text-white mr-2"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                ></path>
              </svg>
              Signing in...
            </span>
          ) : (
            "Sign In"
          )}
        </button>
      </div>
    </div>
  );
};

export default Login;
